import { createApiService } from "@/core/api/apiService";
import type {
  CreatePhoneNumberDto,
  PhoneNumberDto,
  UpdateCallForwardingDto,
  UpdatePhoneNumberDto,
} from "../types/phoneNumberTypes";

export function createPhoneNumberApiClient() {
  const api = createApiService("phone-numbers");

  return {
    getByBusinessId: async (businessId: string, signal?: AbortSignal): Promise<PhoneNumberDto[]> => {
      return api.get<PhoneNumberDto[]>(`/?businessId=${encodeURIComponent(businessId)}`, { signal });
    },

    create: async (data: CreatePhoneNumberDto): Promise<PhoneNumberDto> => {
      return api.post<PhoneNumberDto>("", data);
    },

    update: async (
      id: string,
      data: UpdatePhoneNumberDto
    ): Promise<PhoneNumberDto> => {
      return api.put<PhoneNumberDto>(`/${id}`, data);
    },

    updateForwarding: async (
      id: string,
      businessId: string,
      data: UpdateCallForwardingDto
    ): Promise<PhoneNumberDto> => {
      return api.put<PhoneNumberDto>(
        `/${encodeURIComponent(id)}/forwarding?businessId=${encodeURIComponent(businessId)}`,
        data
      );
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

const phoneNumberApiService = createPhoneNumberApiClient();
export { phoneNumberApiService };
